import React from "react";
import { useTranslation } from "react-i18next";
import { ScrollPane } from "@common/scrollPane";
import { Loader } from "@common/loader";
import { MessageBubble } from "./messageBubble";
import { Props } from "./types";
import styles from "./styles.scss";

function Messages({ messages, isPending, isStreaming, statusMessage }: Props) {
  const { t } = useTranslation();
  const bottomRef = React.useRef<HTMLDivElement>(null);
  const lastMessage = messages[messages.length - 1];

  React.useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: "end" });
  }, [messages.length, lastMessage?.content]);

  return (
    <ScrollPane style={styles.scrollPane}>
      <div className={styles.messages}>
        {isPending && <Loader />}
        {!isPending && messages.length === 0 && (
          <p className={styles.placeholder}>{t("chatbot.messages.empty")}</p>
        )}
        {messages.map((message, index) => (
          <MessageBubble key={index} message={message} />
        ))}
        {isStreaming && !!statusMessage && (
          <p className={styles.statusMessage}>{statusMessage}</p>
        )}
        <div ref={bottomRef} />
      </div>
    </ScrollPane>
  );
}

export { Messages };
